// hooks/useInviteMember.js
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useInviteMember = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ leagueId, userEmail }) => {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = await getAccessTokenSilently();

      const response = await axios.post(
        `${apiUrl}/api/league/league-invite`,
        { leagueId, userEmail },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        // Assuming you have league details or member lists queries that need to be updated
        queryClient.invalidateQueries("leagueDetails");
        queryClient.invalidateQueries("leagueMembers");
      },
    }
  );
};
